const password = {
  setUsername: ({ state }, payload) => {
    state.password.username = payload
  },
  setPassword: ({ state }, payload) => {
    state.password.password = payload
  },
}

export { password }
